import React, { useState, useEffect } from "react";
import { FiX } from "react-icons/fi";
import {
    FaPhone, FaEnvelope
} from 'react-icons/fa';
import { getDatabase, ref, set, get } from "firebase/database";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import { useNavigate } from "react-router-dom";
import img1 from '../../assets/img1.jpeg';

function PublicRegistration() {
    const navigate = useNavigate();


    // Form state - EXACTLY same as RegistrationForm.js
    const [formData, setFormData] = useState({
        personal: {
            phoneNumber: "",
            firstName: "",
            middleName: "",
            lastName: "",
            dateOfBirth: "",
            birthTime: "",
            heightFeet: "",
            heightInches: "",
            maritalStatus: "",
            gender: "Female",
            religion: "Hindu",
            caste: "Maratha",
            interCasteAllowed: "",
            referralCode: "",
        },
        educational: {
            education: "",
            profession: "",
            currentPlace: "",
            nativePlace: "",
            taluka: "",
            state: "Maharashtra",
            district: "Sangli",
        },
        contact: {
            whatsappNumber: "",
            callingNumber: "",
        },
        photos: [],
        biodata: null,
    });

    const [errors, setErrors] = useState({});
    const [submissionStatus, setSubmissionStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    // Dropdown options - EXACTLY same as RegistrationForm.js
    const maritalStatusOptions = ["Single", "Married", "Divorced", "Widowed"];
    const genderOptions = ["Female", "Male"];
    const religionOptions = ["Hindu", "Muslim", "Christian", "Sikh", "Jain", "Buddhist", "Parsi", "Jewish", "Other"];
    const casteOptions = {
        Hindu: [
            "Agarwal", "Agri", "Beldar", "Bhandari", "Bhavsar", "Bhoi", "Brahmin", "CKP (Chandraseniya Kayastha Prabhu)",
            "Chambhar", "Daivadnya Brahmin", "Deshastha Brahmin", "Dhangar", "Dhobi", "Gabit", "Gosavi",
            "GSB (Gaud Saraswat Brahmin)", "Gurav", "Gurjar", "Karhade Brahmin", "Kasar", "Kharvi", "Khatik",
            "Kokanastha Brahmin", "Koli", "Koshti", "Kumbhar", "Kunbi", "Lingayat", "Lohana", "Lohar", "Mahar",
            "Maheshwari", "Mali", "Mang", "Maratha", "Marwari", "Matang", "Nhavi", "Oswal", "Otari", "Parit",
            "Phasepardhi", "Rajput", "Ramoshi", "Rangari", "Shimpi", "Sindhi", "Sutar", "Teli", "Twashta Kasar",
            "Vairagi", "Vanjari", "Other"
        ],
        Muslim: ["Pathan", "Sayyad", "Sheikh", "Shia", "Sunni", "Other"],
        Christian: ["Catholic", "Methodist", "Pentecostal", "Protestant", "Other"],
        Sikh: ["Jat", "Khatri", "Ramgarhia", "Other"],
        Jain: ["Digambara", "Khandelwal", "Oswal", "Svetambara", "Other"],
        Buddhist: ["Mahayana", "Navayana", "Theravada", "Other"],
        Parsi: ["Irani", "Parsi", "Other"],
        Jewish: ["Bene Israel", "Other"],
        Other: ["Other"],
    };
    const interCasteOptions = ["Yes", "No"];
    const stateOptions = ["Maharashtra", "Bihar"];
    const districtsByState = {
        Maharashtra: [
            "Ahmednagar", "Akola", "Amravati", "Beed", "Bhandara", "Buldhana",
            "Chandrapur", "Chhatrapati Sambhajinagar", "Dharashiv",
            "Dhule", "Gadchiroli", "Gondia", "Hingoli", "Jalgaon", "Jalna", "Kolhapur",
            "Latur", "Mumbai City", "Mumbai Suburban", "Nagpur", "Nanded", "Nandurbar",
            "Nashik", "Palghar", "Parbhani", "Pune", "Raigad", "Ratnagiri", "Sangli",
            "Satara", "Sindhudurg", "Solapur", "Thane", "Wardha", "Washim", "Yavatmal"
        ],
        Bihar: [
            "Araria", "Arwal", "Aurangabad", "Banka", "Begusarai", "Bhagalpur", "Bhojpur", "Buxar",
            "Darbhanga", "East Champaran", "Gaya", "Gopalganj", "Jamui", "Jehanabad", "Kaimur",
            "Katihar", "Khagaria", "Kishanganj", "Lakhisarai", "Madhepura", "Madhubani", "Munger",
            "Muzaffarpur", "Nalanda", "Nawada", "Patna", "Purnia", "Rohtas", "Saharsa",
            "Samastipur", "Saran", "Sheikhpura", "Sheohar", "Sitamarhi", "Siwan", "Supaul",
            "Vaishali", "West Champaran"
        ]
    };

    const [editMode, setEditMode] = useState(false);
    const [editUserId, setEditUserId] = useState(null);
    const [existingPhotos, setExistingPhotos] = useState([]);
    const [existingBiodata, setExistingBiodata] = useState(null);

    // Extract referral code or edit param from URL on mount
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const refCode = params.get('ref');
        const editId = params.get('edit');

        if (refCode) {
            setFormData(prev => ({
                ...prev,
                personal: {
                    ...prev.personal,
                    referralCode: refCode
                }
            }));
        }

        if (editId) {
            setEditMode(true);
            setEditUserId(editId);
            fetchUserData(editId);
        }
    }, []);

    const fetchUserData = async (userId) => {
        setIsLoading(true);
        try {
            const db = getDatabase();
            const snapshot = await get(ref(db, `Matrimony/users/${userId}`));
            if (snapshot.exists()) {
                const data = snapshot.val();
                setFormData({
                    personal: { ...data.personal },
                    educational: { ...data.educational },
                    contact: { ...data.contact },
                    photos: [], // New photos to be uploaded
                    biodata: null, // New biodata to be uploaded
                });
                setExistingPhotos(data.photos || []);
                setExistingBiodata(data.biodata || null);
            }
        } catch (error) {
            console.error("Error fetching user data:", error);
            setSubmissionStatus({ type: "error", message: "Failed to load user data" });
        } finally {
            setIsLoading(false);
        }
    };

    // Handle input changes - EXACTLY same as RegistrationForm.js
    const handleInputChange = (section, e) => {
        const { name, value } = e.target;
        setFormData((prev) => {
            const newFormData = {
                ...prev,
                [section]: { ...prev[section], [name]: value },
            };
            if (section === "personal" && name === "phoneNumber" && !editMode) {
                newFormData.contact = {
                    ...newFormData.contact,
                    callingNumber: value
                };
            }
            // If state is changed in educational details, update district to first available
            if (section === "educational" && name === "state") {
                newFormData.educational = {
                    ...newFormData.educational,
                    state: value,
                    district: districtsByState[value]?.[0] || ""
                };
            }
            return newFormData;
        });
        setErrors((prev) => ({ ...prev, [section]: { ...prev[section], [name]: "" } }));
    };

    const handleFileChange = (type, e) => {
        const newFiles = Array.from(e.target.files);
        if (type === "photos") {
            const combinedFiles = [...formData.photos, ...newFiles];
            if (combinedFiles.length + existingPhotos.length > 5) {
                setErrors((prev) => ({ ...prev, photos: "Maximum 5 photos allowed" }));
                return;
            }
            setFormData((prev) => ({
                ...prev,
                photos: combinedFiles,
            }));
            document.getElementById("photos").value = "";
        } else if (type === "biodata") {
            setFormData((prev) => ({
                ...prev,
                biodata: newFiles[0],
            }));
        }
        setErrors((prev) => ({ ...prev, [type]: "" }));
    };

    // Validate form - EXACTLY same as RegistrationForm.js
    const validateForm = () => {
        const newErrors = { personal: {}, educational: {}, contact: {}, photos: "", biodata: "" };
        if (!formData.personal.phoneNumber.trim() || !/^\d{10}$/.test(formData.personal.phoneNumber.trim()))
            newErrors.personal.phoneNumber = "Enter a valid 10-digit phone number";
        if (!formData.personal.firstName.trim()) newErrors.personal.firstName = "Required";
        if (!formData.personal.lastName.trim()) newErrors.personal.lastName = "Required";
        if (!formData.personal.dateOfBirth) newErrors.personal.dateOfBirth = "Required";
        if (!formData.personal.heightFeet || formData.personal.heightFeet < 1 || formData.personal.heightFeet > 10)
            newErrors.personal.heightFeet = "1–10";
        if (!formData.personal.heightInches || (formData.personal.heightInches !== "" && (formData.personal.heightInches < 0 || formData.personal.heightInches > 11)))
            newErrors.personal.heightInches = "0–11";
        if (!formData.personal.maritalStatus) newErrors.personal.maritalStatus = "Required";
        if (!formData.personal.gender) newErrors.personal.gender = "Required";
        if (!formData.personal.religion) newErrors.personal.religion = "Required";
        if (!formData.personal.caste) newErrors.personal.caste = "Required";
        if (!formData.personal.interCasteAllowed) newErrors.personal.interCasteAllowed = "Required";
        if (!formData.educational.education) newErrors.educational.education = "Required";
        if (!formData.educational.profession) newErrors.educational.profession = "Required";
        if (!formData.educational.currentPlace.trim()) newErrors.educational.currentPlace = "Required";
        if (!formData.educational.nativePlace.trim()) newErrors.educational.nativePlace = "Required";
        if (!formData.educational.taluka) newErrors.educational.taluka = "Required";
        if (!formData.educational.state) newErrors.educational.state = "Required";
        if (!formData.educational.district) newErrors.educational.district = "Required";
        const phoneRegex = /^\d{10}$/;
        if (!formData.contact.whatsappNumber || !phoneRegex.test(formData.contact.whatsappNumber))
            newErrors.contact.whatsappNumber = "Invalid phone number";
        if (!formData.contact.callingNumber || !phoneRegex.test(formData.contact.callingNumber))
            newErrors.contact.callingNumber = "Invalid phone number";

        if (formData.photos.length === 0 && existingPhotos.length === 0) newErrors.photos = "At least one photo required";
        if (!formData.biodata && !existingBiodata) newErrors.biodata = "Biodata photo required";

        setErrors(newErrors);
        return (
            Object.values(newErrors.personal).every((e) => !e) &&
            Object.values(newErrors.educational).every((e) => !e) &&
            Object.values(newErrors.contact).every((e) => !e) &&
            !newErrors.photos &&
            !newErrors.biodata
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            setSubmissionStatus({ type: "error", message: "Please fix the errors in the form" });
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }

        setIsLoading(true);
        setUploadProgress(0);

        try {
            const db = getDatabase();
            const storage = getStorage();
            const userKey = formData.personal.phoneNumber.replace(/[^0-9]/g, "");

            // Initial existence check - only for new registrations
            if (!editMode) {
                const snapshot = await get(ref(db, `Matrimony/users/${userKey}`));
                if (snapshot.exists()) {
                    setSubmissionStatus({ type: "error", message: "User already registered with this phone number!" });
                    setIsLoading(false);
                    return;
                }
            }

            const targetUserId = editMode ? editUserId : userKey;
            const userRef = ref(db, `Matrimony/users/${targetUserId}`);

            const totalFiles = formData.photos.length + (formData.biodata ? 1 : 0);
            let uploadedFiles = 0;

            const photoUrls = await Promise.all(
                formData.photos.map(async (file, index) => {
                    const photoRef = storageRef(storage, `Matrimony/users/${targetUserId}/photos/photo_${index}_${Date.now()}`);
                    await uploadBytes(photoRef, file);
                    uploadedFiles++;
                    setUploadProgress((uploadedFiles / totalFiles) * 100 || 0);
                    return getDownloadURL(photoRef);
                })
            );

            let biodataUrl = existingBiodata;
            if (formData.biodata) {
                const biodataRef = storageRef(storage, `Matrimony/users/${targetUserId}/biodata/biodata_${Date.now()}`);
                await uploadBytes(biodataRef, formData.biodata);
                uploadedFiles++;
                setUploadProgress((uploadedFiles / totalFiles) * 100 || 0);
                biodataUrl = await getDownloadURL(biodataRef);
            }

            const finalUserData = {
                personal: formData.personal,
                educational: formData.educational,
                contact: formData.contact,
                photos: [...existingPhotos, ...photoUrls],
                biodata: biodataUrl,
                state: formData.educational.state, // Add top-level state for indexing
                updatedAt: Date.now(),
            };

            if (!editMode) {
                finalUserData.timestamp = Date.now();
            }

            await set(userRef, finalUserData);

            if (formData.personal.referralCode && !editMode) {
                const referralRef = ref(db, `Matrimony/referrals/${formData.personal.referralCode}/${userKey}`);
                await set(referralRef, {
                    userId: userKey,
                    fullName: `${formData.personal.firstName} ${formData.personal.lastName}`,
                    timestamp: Date.now()
                });
            }

            setSubmissionStatus({
                type: "success",
                message: editMode ? "Profile updated successfully!" : "Registration successful! Redirecting to login..."
            });

            setTimeout(() => {
                if (editMode) {
                    navigate('/admin');
                } else {
                    navigate('/login');
                }
            }, 3000);
        } catch (error) {
            setSubmissionStatus({ type: "error", message: `Error: ${error.message}` });
        } finally {
            setIsLoading(false);
        }
    };

    // Responsive check
    const isMobile = window.innerWidth < 768;
    const isTablet = window.innerWidth >= 768 && window.innerWidth < 1200;

    // --- STYLES EXACTLY FROM RegistrationForm.js ---
    const formContainerStyle = {
        borderRadius: "12px",
        boxShadow: "0 6px 18px rgba(0, 0, 0, 0.1)",
        padding: isMobile ? "16px" : "24px",
        width: "100%",
        maxWidth: "1200px",
        background: "linear-gradient(135deg, #c3dafe 0%, #e9d5ff 100%)",
        boxSizing: "border-box",
        marginBottom: "20px",
        border: "1px solid rgba(106, 17, 203, 0.2)",
    };

    const formTitleStyle = {
        fontSize: isMobile ? "1.7rem" : "2rem",
        fontWeight: "620",
        marginBottom: "16px",
        marginTop: "0px",
        background: "linear-gradient(90deg, #6a11cb, #2575fc)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        textAlign: isMobile ? "center" : "left",
    };

    const formGridStyle = {
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : isTablet ? "1fr 1fr" : "1fr 1fr 1fr 1fr",
        gap: isMobile ? "10px" : "14px",
    };

    const inputGroupStyle = { marginBottom: "12px", position: "relative" };
    const labelStyle = { display: "block", fontSize: isMobile ? "0.8rem" : "0.9rem", fontWeight: "600", color: "#1a1a1a", marginBottom: "6px" };
    const inputStyle = { width: "100%", padding: isMobile ? "9px" : "11px", border: "1px solid #d1d5db", borderRadius: "8px", fontSize: isMobile ? "0.9rem" : "0.95rem", boxSizing: "border-box", outline: "none", background: "#fafafa", color: "#1a1a1a" };

    const selectStyle = { ...inputStyle, appearance: "none", background: `url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBmaWxsPSIjMTgxODE4IiBkPSJNOCAxMkwzIDcgNiA0IDggNiAxMCA0IDEzIDd6Ii8+PC9zdmc+") no-repeat right 12px center, #fafafa`, backgroundSize: "12px", paddingRight: "30px" };
    const errorStyle = { fontSize: "0.75rem", color: "#e11d48", marginTop: "4px", display: "block", fontWeight: "500" };
    const submitButtonStyle = { background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)", color: "#ffffff", border: "none", borderRadius: "10px", padding: isMobile ? "10px 20px" : "12px 24px", cursor: "pointer", fontSize: isMobile ? "0.9rem" : "1rem", fontWeight: "600", display: "block", margin: "36px auto 0" };
    const photoPreviewStyle = { display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" };
    const previewImageStyle = { width: isMobile ? "64px" : "80px", height: isMobile ? "64px" : "80px", objectFit: "cover", borderRadius: "10px", border: "2px solid #6a11cb" };

    const siteHeaderStyle = {
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        position: 'fixed',
        top: 0,
        width: '100%',
        zIndex: 1000,
        boxShadow: '0 2px 20px rgba(0,0,0,0.1)',
        padding: '0.5rem 0'
    };

    const siteFooterStyle = {
        background: '#1e293b',
        color: 'white',
        padding: '3rem 2rem 1rem',
        marginTop: '40px'
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#f7f7f7' }}>
            {/* Header */}
            <header style={siteHeaderStyle}>
                <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 2rem' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', cursor: 'pointer' }} onClick={() => navigate('/')}>
                        <img src={img1} alt="Logo" style={{ width: '45px', height: '45px', borderRadius: '8px' }} />
                        <h1 style={{ margin: 0, fontSize: '1.6rem', fontWeight: 'bold', background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Swrajya Sangam</h1>
                    </div>
                    <nav style={{ display: 'flex', gap: '1.5rem', alignItems: 'center' }}>
                        <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', color: '#1e293b', fontWeight: '600', cursor: 'pointer' }}>Home</button>
                        <button onClick={() => navigate('/login')} style={{ background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)', color: 'white', border: 'none', padding: '0.6rem 1.5rem', borderRadius: '30px', fontWeight: 'bold', cursor: 'pointer' }}>Login</button>
                    </nav>
                </div>
            </header>

            {/* Main Form */}
            <main style={{ padding: '100px 20px 40px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {isLoading && (
                    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', zIndex: 2000, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: 'white' }}>
                        <h2>Uploading Data...</h2>
                        <div style={{ width: '80%', maxWidth: '400px', height: '10px', background: '#eee', borderRadius: '5px', margin: '20px 0', overflow: 'hidden' }}>
                            <div style={{ width: `${uploadProgress}%`, height: '100%', background: '#6a11cb' }} />
                        </div>
                        <p>{Math.round(uploadProgress)}% Complete</p>
                    </div>
                )}

                <div style={{ maxWidth: '1200px', width: '100%' }}>
                    {/* PERSONAL */}
                    <div style={formContainerStyle}>
                        <h2 style={formTitleStyle}>Personal Details</h2>
                        <div style={formGridStyle}>
                            <div style={inputGroupStyle}>
                                <label style={labelStyle}>Phone Number *</label>
                                <input style={inputStyle} type="text" name="phoneNumber" value={formData.personal.phoneNumber} onChange={(e) => handleInputChange("personal", e)} placeholder="10 Digits" maxLength="10" />
                                {errors.personal?.phoneNumber && <span style={errorStyle}>{errors.personal.phoneNumber}</span>}
                            </div>
                            <div style={inputGroupStyle}><label style={labelStyle}>First Name *</label><input style={inputStyle} type="text" name="firstName" value={formData.personal.firstName} onChange={(e) => handleInputChange("personal", e)} />{errors.personal?.firstName && <span style={errorStyle}>{errors.personal.firstName}</span>}</div>
                            <div style={inputGroupStyle}><label style={labelStyle}>Middle Name</label><input style={inputStyle} type="text" name="middleName" value={formData.personal.middleName} onChange={(e) => handleInputChange("personal", e)} /></div>
                            <div style={inputGroupStyle}><label style={labelStyle}>Last Name *</label><input style={inputStyle} type="text" name="lastName" value={formData.personal.lastName} onChange={(e) => handleInputChange("personal", e)} />{errors.personal?.lastName && <span style={errorStyle}>{errors.personal.lastName}</span>}</div>
                            <div style={inputGroupStyle}><label style={labelStyle}>Date of Birth *</label><input style={inputStyle} type="date" name="dateOfBirth" value={formData.personal.dateOfBirth} onChange={(e) => handleInputChange("personal", e)} />{errors.personal?.dateOfBirth && <span style={errorStyle}>{errors.personal.dateOfBirth}</span>}</div>
                            <div style={inputGroupStyle}><label style={labelStyle}>Birth Time</label><input style={inputStyle} type="time" name="birthTime" value={formData.personal.birthTime} onChange={(e) => handleInputChange("personal", e)} /></div>
                            <div style={inputGroupStyle}>
                                <label style={labelStyle}>Height *</label>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <input style={{ ...inputStyle, width: '50%' }} type="number" name="heightFeet" placeholder="Ft" value={formData.personal.heightFeet} onChange={(e) => handleInputChange("personal", e)} />
                                    <input style={{ ...inputStyle, width: '50%' }} type="number" name="heightInches" placeholder="In" value={formData.personal.heightInches} onChange={(e) => handleInputChange("personal", e)} />
                                </div>
                                {errors.personal?.heightFeet && <span style={errorStyle}>{errors.personal.heightFeet}</span>}
                            </div>
                            <div style={inputGroupStyle}>
                                <label style={labelStyle}>Marital Status *</label>
                                <select style={selectStyle} name="maritalStatus" value={formData.personal.maritalStatus} onChange={(e) => handleInputChange("personal", e)}>
                                    <option value="">Select</option>
                                    {maritalStatusOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                </select>
                                {errors.personal?.maritalStatus && <span style={errorStyle}>{errors.personal.maritalStatus}</span>}
                            </div>
                            <div style={inputGroupStyle}>
                                <label style={labelStyle}>Gender *</label>
                                <select style={selectStyle} name="gender" value={formData.personal.gender} onChange={(e) => handleInputChange("personal", e)}>
                                    {genderOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                </select>
                            </div>
                            <div style={inputGroupStyle}>
                                <label style={labelStyle}>Religion *</label>
                                <select style={selectStyle} name="religion" value={formData.personal.religion} onChange={(e) => handleInputChange("personal", e)}>
                                    {religionOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                </select>
                            </div>
                            <div style={inputGroupStyle}>
                                <label style={labelStyle}>Caste *</label>
                                <select style={selectStyle} name="caste" value={formData.personal.caste} onChange={(e) => handleInputChange("personal", e)}>
                                    {(casteOptions[formData.personal.religion] || casteOptions.Other).map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                </select>
                            </div>
                            <div style={inputGroupStyle}>
                                <label style={labelStyle}>Inter-Caste Allowed *</label>
                                <select style={selectStyle} name="interCasteAllowed" value={formData.personal.interCasteAllowed} onChange={(e) => handleInputChange("personal", e)}>
                                    <option value="">Select</option>
                                    {interCasteOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                </select>
                                {errors.personal?.interCasteAllowed && <span style={errorStyle}>{errors.personal.interCasteAllowed}</span>}
                            </div>
                        </div>
                    </div>

                    {/* EDUCATIONAL */}
                    <div style={formContainerStyle}>
                        <h2 style={formTitleStyle}>Educational Details</h2>
                        <div style={formGridStyle}>
                            <div style={inputGroupStyle}><label style={labelStyle}>Education *</label><input style={inputStyle} type="text" name="education" value={formData.educational.education} onChange={(e) => handleInputChange("educational", e)} />{errors.educational?.education && <span style={errorStyle}>{errors.educational.education}</span>}</div>
                            <div style={inputGroupStyle}><label style={labelStyle}>Profession *</label><input style={inputStyle} type="text" name="profession" value={formData.educational.profession} onChange={(e) => handleInputChange("educational", e)} />{errors.educational?.profession && <span style={errorStyle}>{errors.educational.profession}</span>}</div>
                            <div style={inputGroupStyle}><label style={labelStyle}>Current Place *</label><input style={inputStyle} type="text" name="currentPlace" value={formData.educational.currentPlace} onChange={(e) => handleInputChange("educational", e)} />{errors.educational?.currentPlace && <span style={errorStyle}>{errors.educational.currentPlace}</span>}</div>
                            <div style={inputGroupStyle}><label style={labelStyle}>Native Place *</label><input style={inputStyle} type="text" name="nativePlace" value={formData.educational.nativePlace} onChange={(e) => handleInputChange("educational", e)} />{errors.educational?.nativePlace && <span style={errorStyle}>{errors.educational.nativePlace}</span>}</div>
                            <div style={inputGroupStyle}><label style={labelStyle}>Taluka *</label><input style={inputStyle} type="text" name="taluka" value={formData.educational.taluka} onChange={(e) => handleInputChange("educational", e)} />{errors.educational?.taluka && <span style={errorStyle}>{errors.educational.taluka}</span>}</div>
                            <div style={inputGroupStyle}>
                                <label style={labelStyle}>State *</label>
                                <select style={selectStyle} name="state" value={formData.educational.state} onChange={(e) => handleInputChange("educational", e)}>
                                    <option value="">Select State</option>
                                    {stateOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                </select>
                                {errors.educational?.state && <span style={errorStyle}>{errors.educational.state}</span>}
                            </div>
                            <div style={inputGroupStyle}>
                                <label style={labelStyle}>District *</label>
                                <select style={selectStyle} name="district" value={formData.educational.district} onChange={(e) => handleInputChange("educational", e)}>
                                    <option value="">Select District</option>
                                    {(districtsByState[formData.educational.state] || []).map(opt => <option key={opt} value={opt}>{opt}</option>)}
                                </select>
                                {errors.educational?.district && <span style={errorStyle}>{errors.educational.district}</span>}
                            </div>
                        </div>
                    </div>

                    {/* CONTACT */}
                    <div style={formContainerStyle}>
                        <h2 style={formTitleStyle}>Contact Details</h2>
                        <div style={formGridStyle}>
                            <div style={inputGroupStyle}>
                                <label style={labelStyle}>WhatsApp Number *</label>
                                <input style={inputStyle} type="text" name="whatsappNumber" value={formData.contact.whatsappNumber} onChange={(e) => handleInputChange("contact", e)} />
                                {errors.contact?.whatsappNumber && <span style={errorStyle}>{errors.contact.whatsappNumber}</span>}
                            </div>
                            <div style={inputGroupStyle}>
                                <label style={labelStyle}>Calling Number *</label>
                                <input style={{ ...inputStyle, background: '#eee' }} type="text" value={formData.personal.phoneNumber} readOnly />
                            </div>
                        </div>
                    </div>

                    {/* MEDIA */}
                    <div style={formContainerStyle}>
                        <h2 style={formTitleStyle}>Photo Upload</h2>
                        <div style={inputGroupStyle}>
                            <label style={labelStyle}>Photos (max 5) *</label>
                            <input type="file" id="photos" multiple accept="image/*" onChange={(e) => handleFileChange("photos", e)} />
                            <div style={photoPreviewStyle}>
                                {/* Existing Photos */}
                                {existingPhotos.map((url, i) => (
                                    <div key={`existing-${i}`} style={{ position: 'relative' }}>
                                        <img src={url} style={previewImageStyle} alt="existing" />
                                        <FiX style={{ position: 'absolute', top: -5, right: -5, color: 'red', cursor: 'pointer', background: 'white', borderRadius: '50%' }} onClick={() => {
                                            const newExisting = [...existingPhotos];
                                            newExisting.splice(i, 1);
                                            setExistingPhotos(newExisting);
                                        }} />
                                    </div>
                                ))}
                                {/* New Photos */}
                                {formData.photos.map((file, i) => (
                                    <div key={`new-${i}`} style={{ position: 'relative' }}>
                                        <img src={URL.createObjectURL(file)} style={previewImageStyle} alt="preview" />
                                        <FiX style={{ position: 'absolute', top: -5, right: -5, color: 'red', cursor: 'pointer', background: 'white', borderRadius: '50%' }} onClick={() => {
                                            const newPhotos = [...formData.photos];
                                            newPhotos.splice(i, 1);
                                            setFormData(p => ({ ...p, photos: newPhotos }));
                                        }} />
                                    </div>
                                ))}
                            </div>
                            {errors.photos && <span style={errorStyle}>{errors.photos}</span>}
                        </div>
                        <div style={inputGroupStyle}>
                            <label style={labelStyle}>Biodata Image *</label>
                            <input type="file" id="biodata" accept="image/*" onChange={(e) => handleFileChange("biodata", e)} />
                            {formData.biodata ? (
                                <div style={{ position: 'relative', display: 'inline-block', marginTop: 10 }}>
                                    <img src={URL.createObjectURL(formData.biodata)} style={previewImageStyle} alt="new-biodata" />
                                    <FiX style={{ position: 'absolute', top: -5, right: -5, color: 'red', cursor: 'pointer', background: 'white', borderRadius: '50%' }} onClick={() => setFormData(p => ({ ...p, biodata: null }))} />
                                </div>
                            ) : existingBiodata && (
                                <div style={{ position: 'relative', display: 'inline-block', marginTop: 10 }}>
                                    <img src={existingBiodata} style={previewImageStyle} alt="existing-biodata" />
                                    <FiX style={{ position: 'absolute', top: -5, right: -5, color: 'red', cursor: 'pointer', background: 'white', borderRadius: '50%' }} onClick={() => setExistingBiodata(null)} />
                                </div>
                            )}
                            {errors.biodata && <span style={errorStyle}>{errors.biodata}</span>}
                        </div>
                    </div>

                    {formData.personal.referralCode && (
                        <div style={{ background: '#f0fdf4', padding: '15px', borderRadius: '10px', border: '1px dashed #22c55e', color: '#15803d', marginBottom: '20px', textAlign: 'center' }}>
                            Referral Applied: {formData.personal.referralCode}
                        </div>
                    )}

                    <button style={submitButtonStyle} onClick={handleSubmit}>
                        {editMode ? "Update Profile Details" : "Save All Details & Register"}
                    </button>
                    {submissionStatus && <div style={{ color: submissionStatus.type === 'success' ? 'green' : 'red', textAlign: 'center', marginTop: 10 }}>{submissionStatus.message}</div>}
                </div>
            </main>

            {/* Footer */}
            <footer style={siteFooterStyle}>
                <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', gap: '2rem', justifyContent: 'space-between' }}>
                    <div style={{ flex: 1, minWidth: '250px' }}>
                        <h3 style={{ color: 'white' }}>Swrajya Sangam</h3>
                        <p style={{ color: '#94a3b8' }}>Providing trusted matrimony services since 2009.</p>
                    </div>
                    <div>
                        <h4 style={{ color: 'white' }}>Contact</h4>
                        <p style={{ color: '#94a3b8' }}><FaPhone /> +91 9370329233</p>
                        <p style={{ color: '#94a3b8' }}><FaEnvelope /> info@swrajyasangam.com</p>
                    </div>
                </div>
                <div style={{ borderTop: '1px solid #334155', marginTop: '2rem', paddingTop: '1rem', textAlign: 'center', color: '#64748b' }}>
                    © {new Date().getFullYear()} Swrajya Sangam. All rights reserved.
                </div>
            </footer>
        </div>
    );
}

export default PublicRegistration;
